import getIn from 'transmute/getIn';
export const getIndexedAsyncCapabilitiesData = getIn(['threadViewRootReducer', 'capabilitiesData']);